import { EntityType } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { PinCodeClient } from '@frontend/pin-code/api';
import { PinCode } from '@frontend/pin-code/types';
import { useAccountRepository } from '@frontend/repository';
import { useCallback, useEffect, useState } from 'react';

import { MasterPinCodeContainerProps } from './master-pin-code-container.component';

export const useMasterPinCodeContainer = (props: MasterPinCodeContainerProps) => {
    const { currentAccount } = useAccountRepository();
    const { openModal } = useModals();
    const MASTER_PIN_CODE_MODAL_ID = 'MASTER_PIN_CODE_MODAL_ID';
    const [pinCode, setPinCode] = useState<PinCode | null>(null);
    const fetchPinCode = useCallback(async () => {
        try {
            const pinCodes = await PinCodeClient.fetchPinCodes({ account_id: currentAccount, entity_type: EntityType.IOT, entity_id: props.iot_id });
            if (pinCodes.results.length > 0) {
                setPinCode(pinCodes.results[0]);
            } else setPinCode(null);
        } catch {
            setPinCode(null);
        }
    }, [props.iot_id, currentAccount]);

    useEffect(() => {
        if (!props.iot_id) return;
        fetchPinCode();
    }, [props.iot_id, fetchPinCode]);

    return {
        pinCode,
        openModal,
        MASTER_PIN_CODE_MODAL_ID,
        setPinCode
    };
};
